// src/utils/shipping.js — Maxula
// Miroir client du calcul de tarif au poids (Lot D). Sert à l'ESTIMATION
// (checkout, fiche produit). La source de vérité reste le serveur au moment
// de la commande.

export function parseTiers(raw) {
  let arr = raw;
  if (typeof arr === "string") { try { arr = JSON.parse(arr); } catch { arr = []; } }
  if (!Array.isArray(arr)) return [];
  return arr
    .map((t) => ({ uptoGrams: Number(t && t.uptoGrams) || 0, fee: Math.max(0, Number(t && t.fee) || 0) }))
    .filter((t) => t.uptoGrams > 0)
    .sort((a, b) => a.uptoGrams - b.uptoGrams);
}

export function feeFromWeight(tiers, grams, fallbackFee = 0) {
  const sorted = parseTiers(tiers);
  if (!sorted.length) return Math.max(0, Number(fallbackFee) || 0);
  const g = Math.max(0, Number(grams) || 0);
  const hit = sorted.find((t) => g <= t.uptoGrams);
  return hit ? hit.fee : sorted[sorted.length - 1].fee;
}
